export const SNACK_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
};

export const SNACK_CLASSES = {
  CUSTOM_SIDESHEET: 'custom-sidesheet',
  CUSTOM_SIDESHEET_PREVIEW: 'custom-sidesheet--preview',
};
